export enum ChargeStatus {
    successful = "successful",
    pending = "pending",
    failed = "failed",
}